<template>
  <v-card
    class="dashboard-block d-flex flex-column"
    height="100%"
  >
    <v-card-title class="text-subtitle-1 font-weight-semibold">
      {{ title }}
    </v-card-title>

    <v-card-subtitle
      v-if="caption !== null"
      class="text-caption pb-0"
    >
      {{ captionText }}
    </v-card-subtitle>

    <v-card-text
      class="flex-grow-1 pt-3"
      :style="{ minHeight: `${minHeight}px` }"
    >
      <v-skeleton-loader
        v-if="loading"
        :type="skeleton"
      ></v-skeleton-loader>

      <div
        v-else-if="missing"
        class="d-flex align-center text--secondary"
      >
        <v-icon
          size="20"
          class="me-2"
        >
          {{ icons.mdiAlertCircleOutline }}
        </v-icon>
        <span>Этот блок не прочитался: сервер не прислал его данные. Остальные от него не зависят.</span>
      </div>

      <slot v-else></slot>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiAlertCircleOutline } from '@mdi/js'

export default {
  name: 'DashboardBlock',
  props: {
    title: { type: String, required: true },

    caption: { type: String, default: null },
    loading: { type: Boolean, default: false },
    missing: { type: Boolean, default: false },
    skeleton: { type: String, default: 'text@3' },
    minHeight: { type: Number, default: 0 },
  },
  data: () => ({
    icons: { mdiAlertCircleOutline },
  }),
  computed: {
    captionText() {
      return this.loading || this.missing || !this.caption ? ' ' : this.caption
    },
  },
}
</script>
